import axiosInstance from './axiosInstance'

export type FollowUpType   = 'CALL' | 'MEETING' | 'DEMO' | 'SITE_VISIT' | 'OTHER'
export type FollowUpStatus = 'PENDING' | 'DONE' | 'CANCELLED'

export interface AuditUser {
  id:        string
  name:      string
  email:     string
  avatarUrl: string | null
}

export interface LeadFollowUp {
  id:              string
  leadId?:                string | null
  leadName?:              string | null
  dealId?:                string | null
  dealName?:              string | null
  salesId?:               string | null
  salesTitle?:            string | null
  retentionCustomerId?:   string | null
  retentionCustomerName?: string | null
  contactId?:             string | null
  contactName?:           string | null
  source?:                'LEAD' | 'DEAL' | 'SALES' | 'RETENTION' | 'CONTACT' | string
  title:           string | null
  type:            FollowUpType
  scheduledAt:     string
  endTime:         string | null
  notes:           string | null
  reminderMinutes: number | null
  status:          FollowUpStatus
  outcome:         string | null
  assignedTo:      AuditUser | null
  createdBy:       AuditUser | null
  completedAt:     string | null
  createdAt:       string
  updatedAt:       string
}

export interface PaginatedLeadFollowUps {
  items: LeadFollowUp[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface FollowUpFilters {
  search?: string
  types?: string[]
  statuses?: string[]
  ownerIds?: string[]
  from?: string
  to?: string
  // SuperAdmin / Org Admin: narrow by org / LOB
  orgIds?: string[]
  lobIds?: string[]
}

export interface CreateFollowUpPayload {
  title?:          string
  type:            FollowUpType
  scheduledAt:     string   // ISO string
  endTime?:        string   // ISO string
  notes?:          string
  reminderMinutes?: number
  assignedToId?:   string
}

export interface CompleteFollowUpPayload {
  outcome?: string
}

export const leadFollowUpsApi = {
  getAllForCalendar: (lobIds?: string[]) =>
    axiosInstance
      .get<{ data: LeadFollowUp[] }>('/follow-ups', { params: lobIds?.length ? { lobIds: lobIds.join(',') } : undefined })
      .then(r => r.data.data),

  getPagedForActivity: (page: number, pageSize: number, filters?: FollowUpFilters): Promise<PaginatedLeadFollowUps> =>
    axiosInstance
      .get<{ data: PaginatedLeadFollowUps }>('/follow-ups/paged', {
        params: { page, pageSize, ...filters }
      })
      .then(r => r.data.data),

  getAll: (leadId: string) =>
    axiosInstance
      .get<{ data: LeadFollowUp[] }>(`/leads/${leadId}/follow-ups`)
      .then(r => r.data.data),

  create: (leadId: string, payload: CreateFollowUpPayload) =>
    axiosInstance
      .post<{ data: LeadFollowUp[] }>(`/leads/${leadId}/follow-ups`, payload)
      .then(r => r.data.data),

  complete: (leadId: string, fuId: string, payload: CompleteFollowUpPayload = {}) =>
    axiosInstance
      .patch<{ data: LeadFollowUp[] }>(`/leads/${leadId}/follow-ups/${fuId}/complete`, payload)
      .then(r => r.data.data),

  cancel: (leadId: string, fuId: string) =>
    axiosInstance
      .patch<{ data: LeadFollowUp[] }>(`/leads/${leadId}/follow-ups/${fuId}/cancel`)
      .then(r => r.data.data),
}
